jQuery(function ($) {
    let nav = $('.seccond-level-nav__mobile');

    nav.find('.mobile-select').click(function () {
        if ( !$(this).hasClass('disabled') ) {
            $(this).toggleClass('active');
        }
    });
});